import { apiGet, apiPost, apiPut, apiDelete } from './client';

export interface TemplateSummary {
  id: number;
  name: string;
  savedAt: string;
  itemCount?: number;
}

export interface TemplateDetail extends TemplateSummary {
  items: unknown[];   // raw snapshot — same shape as CartItem / OrderItem
}

export const orderTemplatesApi = {
  /** List all templates (no items). */
  list(): Promise<TemplateSummary[]> {
    return apiGet<TemplateSummary[]>('/order-templates');
  },

  /** Create a new template. */
  create(name: string, items: unknown[]): Promise<TemplateSummary> {
    return apiPost<TemplateSummary, { name: string; items: unknown[] }>(
      '/order-templates',
      { name, items },
    );
  },

  /** Update an existing template's name and/or items. */
  update(id: number, name: string | null, items: unknown[] | null): Promise<TemplateSummary> {
    return apiPut<TemplateSummary, { name?: string; items?: unknown[] }>(
      `/order-templates/${id}`,
      { ...(name != null ? { name } : {}), ...(items != null ? { items } : {}) },
    );
  },

  /** Get a template with its items. */
  get(id: number): Promise<TemplateDetail> {
    return apiGet<TemplateDetail>(`/order-templates/${id}`);
  },

  /** Delete a template. */
  delete(id: number): Promise<void> {
    return apiDelete<void>(`/order-templates/${id}`);
  },
};
